export default __webpack_public_path__ + "static/media/needs-placeholder-image.1414bb50.png";